import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectKeys'
})
export class ObjectKeysPipe implements PipeTransform {

  transform(value: Record<string, any> | null | undefined): string[] {
    return value ? Object.keys(value) : [];
  }
}

//maintain the order
@Pipe({
  name: 'keyvalue'
})
export class KeyvaluePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): any {
    if (!value || typeof value !== 'object') {
      return value;
    }

    return Object.keys(value).map(key => ({ key, value: value[key] }));
  }
}

//Sorted Order
@Pipe({
  name: 'keyvalueOrder'
})
export class KeyvalueOrderPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): any {
    if (!value || typeof value !== 'object') {
      return value;
    }

    return Object.keys(value)
      .sort() // Sort the keys alphabetically
      .map(key => ({ key, value: value[key] }));
  }
}